<template>
  <div>
    <div class="tab-title">
      <div v-for="(item, index) in rulesType" :key="`name${index}`" :class="['tab-item', {cur: active === index}]" @click="active = index">{{item.name}}</div>
    </div>
    <div class="attention">
      <div v-html="rulesType[active].value"></div>
      <div class="remark" v-show="active === 1"><span>*</span>皇家加勒比国际游轮在法律允许的范围内保留对以上条款的修改及解释权。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductRules',

  props: {
    productData: Object
  },

  data () {
    return {
      active: 0
    }
  },

  computed: {
    rulesType () {
      return [{
        name: '注意事项',
        value: this.productData.caution
      }, {
        name: '条款细则',
        value: this.productData.terms
      }]
    }
  }
}
</script>

<style lang="less" scoped>
.tab-title {
  display: flex;
  height: 78px;
  border-radius: 6px;
  background-color: #1174b8;
  .tab-item {
    position: relative;
    flex: 1;
    height: 100%;
    font-size: 30px;
    color: #fff;
    text-align: center;
    line-height: 78px;
    &:first-child {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }
    &:last-child {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }
    &.cur {
      .btn-linear-gradient;
      color: #111;
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -10px;
        width: 0;
        height: 0;
        margin-left: -5px;
        border-top: 10px solid #fdc404;
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
      }
    }
  }
}
.attention {
  padding-bottom: 50px;
}
</style>
